import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { BenefitsAndResults } from './components/BenefitsAndResults';
import { WhyItWorks } from './components/WhyItWorks';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Esperar a que fbq esté disponible
    const checkFbq = setInterval(() => {
      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        clearInterval(checkFbq);
        try {
          // Track ViewContent cuando se carga la landing page
          window.fbq('track', 'ViewContent', {
            content_name: 'Cría con calma - Landing Page',
            content_category: 'Parenting Guide',
            content_ids: ['40777014116416'],
            value: 7.99,
            currency: 'USD'
          });
          console.log('✅ ViewContent event tracked');
        } catch (error) {
          console.error('❌ Error tracking ViewContent:', error);
        }
      }
    }, 100);
    // Limpiar el intervalo después de 5 segundos si no se encuentra fbq
    setTimeout(() => clearInterval(checkFbq), 5000);
    // Track scroll depth
    const handleScroll = () => {
      try {
        if (typeof window.fbq !== 'function') return;
        const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
        if (scrollPercent > 25 && !sessionStorage.getItem('scroll_25')) {
          window.fbq('trackCustom', 'ScrollDepth25');
          sessionStorage.setItem('scroll_25', 'true');
          console.log('✅ ScrollDepth25 event tracked');
        }
        if (scrollPercent > 50 && !sessionStorage.getItem('scroll_50')) {
          window.fbq('trackCustom', 'ScrollDepth50');
          sessionStorage.setItem('scroll_50', 'true');
          console.log('✅ ScrollDepth50 event tracked');
        }
        if (scrollPercent > 75 && !sessionStorage.getItem('scroll_75')) {
          window.fbq('trackCustom', 'ScrollDepth75');
          sessionStorage.setItem('scroll_75', 'true');
          console.log('✅ ScrollDepth75 event tracked');
        }
      } catch (error) {
        console.error('❌ Error tracking scroll depth:', error);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full min-h-screen bg-[#FDF9F4]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <BenefitsAndResults data-id="element-5" />
        <WhyItWorks data-id="element-6" />
        <Features data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
        <CTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}